import { ReactElement } from 'react';
import { ToastType, useTosterStore } from '@store/toster';
import { useSiderToggleMenu } from '@store/useSiderToggleMenu';
import { cleanupDatabase } from '@rxdb/config/databaseConfig';
import { useLogoutMutation } from '@services/hooks/login';
import { useBDEOnLeaveStore } from '@store/bdeOnLeaveStore';
import Cookies from 'universal-cookie';
import { clearAllCookies } from '@helper/cookiesClear';
// import { useComponentLevelAccessCheck } from '../../../authGuard/hooks/useComponentLevelAccessCheck';

export const LogoutButton = (): ReactElement => {
	const { setToaster } = useTosterStore();
	const { setFullPageLoader } = useSiderToggleMenu();
	const { isModalOpen, setModalClose } = useBDEOnLeaveStore();
	const { mutate: logout } = useLogoutMutation();
	// const permissionAttendanceCheck = useComponentLevelAccessCheck('attendance-check');
	const handleClearDatabase = async (): Promise<void> => {
		setFullPageLoader(true);
		try {
			await cleanupDatabase();

			localStorage.clear();
			sessionStorage.clear();
			clearAllCookies();

			const clearCacheData = (): void => {
				caches.keys().then((names) => {
					names.forEach((name) => {
						caches.delete(name);
					});
				});
			};
			clearCacheData();

			setTimeout(() => {
				clearAllCookies();
				if (isModalOpen) setModalClose();
				window.location.href = process.env.REACT_APP_FV_REDIRECTION_URL ?? '/login';
			}, 50);
		} catch {
			setToaster(true, ToastType.error, 'Error during logout');
		} finally {
			setFullPageLoader(false);
		}
	};

	const cleanUpStorage = (): void => {
		localStorage.clear();
		sessionStorage.clear();
		clearAllCookies();
		handleClearDatabase().then();
	};

	const handleLogout = async (): Promise<void> => {
		try {
			setFullPageLoader(true);
			const cookie = new Cookies();
			const token = localStorage.getItem('token') ?? sessionStorage.getItem('token') ?? cookie.get('token');
			if (!token) await handleClearDatabase();

			token &&
				logout(token, {
					onSuccess: () => {
						cleanUpStorage();
					},
					onError: () => {
						cleanUpStorage();
					},
				});
		} catch {
			setFullPageLoader(false);
			setToaster(true, ToastType.error, 'Error during logout');
		}
	};

	// UseChecksBDEOnLeaveService({
	// 	apiEnable: permissionAttendanceCheck,
	// });

	return (
		<>
			<button type="button" aria-label="Logout" className="sidebar__link" onClick={handleLogout}>
				<span className="icon-logout" /> Logout
			</button>
			{/* {isModalOpen && (
				<Modal modalId="bdeOnLeave" className="dialog-lg dialog-sm" isEscAllow={false} modalOpen={isModalOpen}>
					<BDEOnLeaveModal
						handleModalClose={() => {
							handleLogout().then();
						}}
					/>
				</Modal>
			)} */}
		</>
	);
};
